import { render, staticRenderFns } from "./WarningBox.vue?vue&type=template&id=675e7468&"
import script from "./WarningBox.vue?vue&type=script&lang=js&"
export * from "./WarningBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports